import {createSvgIcon} from '../create-svg-icon';

export const FormatAlignJustifyIcon = createSvgIcon(
  <path d="M3 21h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18V7H3v2zm0-6v2h18V3H3z" />
, 'FormatAlignJustifyOutlined');
